import { render, staticRenderFns } from "./TabsInfo.vue?vue&type=template&id=5088542a&scoped=true&"
import script from "./TabsInfo.vue?vue&type=script&lang=js&"
export * from "./TabsInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5088542a",
  null
  
)

export default component.exports